import { User } from '@dash.bar/types'
import ColoredText from '@webstollen/react-native/lib/components/CustomText/ColoredText'
import LoadingScreen from '@webstollen/react-native/lib/components/LoadingScreen'
import { useTranslation } from '@webstollen/react-native/lib/hooks/useTranslation'
import { Toast } from 'native-base'
import React, { useState } from 'react'
import { View } from 'react-native'
import getApp from '../../../firebase'
import Button from '../../Button'
import useStyles from '../styles'

export const SetOwnerDialogContent = ({
  user,
  modalRef,
  setSetOwner,
}: {
  user: User
  modalRef: React.MutableRefObject<any>
  setSetOwner: (arg0: boolean) => void
}) => {
  const owner = getApp().functions('us-central1').httpsCallable('auth-user-owner')
  const [settingOwner, setSettingOwner] = useState<boolean>(false)
  const styles = useStyles()
  const { t } = useTranslation()

  if (settingOwner) {
    return <LoadingScreen />
  }
  return (
    <>
      <ColoredText style={styles.modalContentText}>
        <>
          {t('accountOverview.user.submit_promote_owner_text', {
            user: `${user?.firstName} ${user?.lastName}`,
          })}
        </>
      </ColoredText>
      <ColoredText style={styles.modalContentText}>
        <>{t('accountOverview.user.promote_owner_text')}</>
      </ColoredText>
      <View style={styles.buttonWrapper}>
        <Button
          style={styles.cancelButton}
          onPress={() => {
            if (modalRef && modalRef.current) modalRef.current.setVisible(false)
            setSetOwner(false)
          }}
        >
          {t('accountOverview.user.cancel')}
        </Button>
        <Button
          onPress={() => {
            setSettingOwner(true)
            owner({ uid: user.id })
              .then(() => {
                Toast.show({
                  title: t('accountOverview.user.successfully_promoted'),
                })
              })
              .catch((err) => {
                Toast.show({
                  title: t('accountOverview.user.error_promoting'),
                  description: err.message,
                })
              })
              .finally(() => {
                if (modalRef && modalRef.current) modalRef.current.setVisible(false)
                setSettingOwner(false)
                setSetOwner(false)
              })
          }}
          textStyle={{ color: 'white' }}
          style={styles.promoteButton}
        >
          {t('accountOverview.user.promote_owner')}
        </Button>
      </View>
    </>
  )
}
